module.exports = __webpack_public_path__ + "static/img/crown.bf1dce9d.svg";